export const locale = {
    id: 'fr-FR',
    prefix: '',
    mailDomain: 'fr',
};
